import Helpers from '../modules/Helpers'
import XhrPromise from 'xhr-promise'
import Clipboard from 'clipboard'

const emailShare = document.getElementsByClassName('modal-share__email')
const emailShareForm = document.getElementsByClassName('modal-share__email-form')
const emailShareSuccess = document.getElementsByClassName('modal-share__email-success')
const emailShareError = document.getElementsByClassName('modal-share__email-error')

// initiate dialog copy link to clipboard function
new Clipboard(document.getElementsByClassName('modal-share__copy-link'))

new Helpers(document.getElementsByClassName('social-share')).eventListener((e) => {
    let link = e.target.getAttribute('data-link')
    const tweet = e.target.getAttribute('data-tweet')
    const title = e.target.getAttribute('data-title')
    const emailType = e.target.getAttribute('data-emailType')
    const emailData = e.target.getAttribute('data-emailData')
    const emailSubject = e.target.getAttribute('data-emailSubject')
    const message = e.target.getAttribute('data-message')

    const modal = document.getElementById('shareModal')

    // Set form values for email send
    modal.getElementsByClassName('modal-share__title')[0].innerText = title
    modal.getElementsByClassName('modal-share__email-type')[0].value = emailType
    modal.getElementsByClassName('modal-share__email-subject')[0].value = emailSubject
    modal.getElementsByClassName('modal-share__email-data')[0].value = emailData
    modal.getElementsByTagName('textarea')[0].value = message

    if (document.getElementsByClassName('shortlist-home').length > 0) {
        const shareURL = `https://${e.target.getAttribute('data-siteurl')}my-classic/MyShortlist.aspx`
        const slname = encodeURI(e.target.getAttribute('data-shortlistname'))
        const slcodes = Array.from(document.getElementsByClassName('favourite-button')).map(i => i.getAttribute("data-code")).join(",")
        link = `${shareURL}?addShortlist=${slcodes}&slname=${slname}`
    }
    modal.getElementsByClassName('modal-share__shortlist-url')[0].value = link
    // Set links for social buttons
    modal.getElementsByClassName('btn-facebook')[0].href = `https://www.facebook.com/sharer/sharer.php?u=${escape(link)}`
    modal.getElementsByClassName('btn-twitter')[0].href = `https://twitter.com/share/?url=${escape(link)}&text=${escape(tweet)}`
    // set link for copy/paste
    modal.getElementsByClassName('modal-share__share-link-url')[0].value = link

    // Set initial display state of form
    new Helpers(emailShare).setAttributes({ 'aria-hidden': false })
    new Helpers(emailShareSuccess).setAttributes({ 'aria-hidden': true })
    new Helpers(emailShareError).setAttributes({ 'aria-hidden': true })
})

// toggle visiblity of custom email message box
new Helpers(document.getElementsByClassName('modal-share__email-add-message')).eventListener((e) => {
    e.preventDefault()
    e.stopPropagation()

    new Helpers(emailShareForm).toggleClass('add-message')
})

// Handle ajax email send
new Helpers(document.getElementsByClassName('modal-share__email')).eventListener((e) => {
    e.preventDefault()
    const values = []
    Array.from(e.target.elements).forEach((element) => {
        if (element.name !== undefined && element.name !== '') {
            values.push(`${encodeURIComponent(element.name)}=${encodeURIComponent(element.value)}`)
        }
    })
    // hide form to prevent duplicate submission
    new Helpers(emailShare).setAttributes({ 'aria-hidden': true })

    const xhr = new XhrPromise()
    xhr.send({
        url: '/ajax/email.aspx',
        method: 'POST',
        data: values.join('&'),
    })
        .then((response) => {
            return (new window.DOMParser()).parseFromString(response.responseText, "text/xml")
        })
        .then((data) => {

            const results = data.getElementsByTagName('results')[0]
            if (results.getAttribute('outcome') === 'sent') {
                new Helpers(emailShareSuccess).setAttributes({ 'aria-hidden': false })
            } else {
                new Helpers(emailShareError).setAttributes({ 'aria-hidden': false })
            }
        }).catch((ex) => {
            new Helpers(emailShareError).setAttributes({ 'aria-hidden': false })
        })

}, 'submit')
